import './style.scss';

// core version + navigation, pagination modules:
import Swiper, { Autoplay, EffectFade } from 'swiper';

Swiper.use([Autoplay, EffectFade]);

const option = {
	slidesPerView: 1,
	loop: true,
	effect: 'fade',
	fadeEffect: {
		crossFade: true,
	},
	speed: 1000,
	autoplay: {
		delay: 3000,
	},
}
// init Swiper:
// eslint-disable-next-line no-unused-vars
const swiper = new Swiper('.mv-slide', option);

